// Mirrors DEALER_HANDS / describeHand in cmsCLub-dev/model/dealerHandEntry.js (same keys,
// weakest first). The backend validates and builds the saved description; this copy only
// drives the dealer's pickers and live preview.
export const HANDS = [
  { key: "FULL_HOUSE", label: "Full House" },
  { key: "QUADS", label: "Four of a Kind", sub: "Quads" },
  { key: "STRAIGHT_FLUSH", label: "Straight Flush" },
  { key: "ROYAL_FLUSH", label: "Royal Straight Flush" },
];

export const handLabel = (key) => {
  const h = HANDS.find((x) => x.key === key);
  return h ? (h.sub ? `${h.label} (${h.sub})` : h.label) : key;
};

// Highest first, as a dealer reads them.
export const RANKS = [14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
export const rankChar = (r) => ({ 10: "10", 11: "J", 12: "Q", 13: "K", 14: "A" }[r] || String(r));

const CODE_CHAR = { 10: "T", 11: "J", 12: "Q", 13: "K", 14: "A" };
const PLURAL = { 2: "Twos", 3: "Threes", 4: "Fours", 5: "Fives", 6: "Sixes", 7: "Sevens", 8: "Eights", 9: "Nines", 10: "Tens", 11: "Jacks", 12: "Queens", 13: "Kings", 14: "Aces" };
const NAME = { 5: "Five", 6: "Six", 7: "Seven", 8: "Eight", 9: "Nine", 10: "Ten", 11: "Jack", 12: "Queen", 13: "King" };
const cc = (r) => CODE_CHAR[r] || String(r);

// What each hand needs picked: [{ field, label, ranks }]
export const rankPickers = (hand) => {
  if (hand === "FULL_HOUSE") return [
    { field: "rank", label: "Three of a kind", ranks: RANKS },
    { field: "rank2", label: "Pair", ranks: RANKS },
  ];
  if (hand === "QUADS") return [{ field: "rank", label: "Four of a kind — which rank?", ranks: RANKS }];
  if (hand === "STRAIGHT_FLUSH") return [{ field: "rank", label: "High card", ranks: [13, 12, 11, 10, 9, 8, 7, 6, 5] }];
  return [];
};

// Preview of the description the backend will save, or null while picks are incomplete.
export const previewHand = (hand, rank, rank2) => {
  if (hand === "FULL_HOUSE") return rank && rank2 && rank !== rank2 ? `Full House, ${PLURAL[rank]} full of ${PLURAL[rank2]} (${cc(rank).repeat(3)}${cc(rank2).repeat(2)})` : null;
  if (hand === "QUADS") return rank ? `Quad ${PLURAL[rank]} (${cc(rank).repeat(4)}x)` : null;
  if (hand === "STRAIGHT_FLUSH") return rank ? `Straight Flush, ${NAME[rank]} High (${rank === 5 ? "A2345" : [4, 3, 2, 1, 0].map((d) => cc(rank - d)).join("")})` : null;
  if (hand === "ROYAL_FLUSH") return "Royal Straight Flush (AKQJT)";
  return null;
};

// "Quad Aces (AAAAx)" -> { name: "Quad Aces", code: "AAAAx" }
export const splitDesc = (desc) => {
  const m = /^(.*?)\s*\(([^)]*)\)$/.exec(desc || "");
  return m ? { name: m[1], code: m[2] } : { name: desc || "", code: "" };
};
